// Phones: pinch-zoom only on maps and proposal photos/videos. Illustrations, text and controls stay at the designed size.
const ZOOMABLE = ".maplibregl-map, [data-zoomable], .story img, .story video, .story iframe";

const guard = (e) => {
  if (e.touches && e.touches.length < 2) return;
  if (e.target?.closest?.(ZOOMABLE)) return;
  e.preventDefault();
};

export const installZoomGuard = () => {
  document.addEventListener("touchmove", guard, { passive: false });
  document.addEventListener("gesturestart", guard, { passive: false });
  document.addEventListener("gesturechange", guard, { passive: false });
};
